import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import "./Importdeck.css";
import { API_URL } from "../../config/constants";
import { logEvent } from "../../hooks/useAnalytics"; // ← Importa el logger

const ImportDeck = () => {
    useEffect(() => {
        fetch(`${API_URL}/endpoint`)
            .then((res) => res.json())
            .then((data) => {
                console.log("Datos:", data);
            })
            .catch((error) => {
                console.error("Error al obtener datos:", error);
            });
    }, []);

    const [deckCode, setDeckCode] = useState("");
    const [cardDatabase, setCardDatabase] = useState([]);
    const [isImporting, setIsImporting] = useState(false);

    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const edition = queryParams.get("edition") || "";

    useEffect(() => {
        fetch(`${API_URL}/cartas?edition=${edition}`)
            .then(response => response.json())
            .then(data => {
                const formattedCards = data.data.map(entry => entry);
                setCardDatabase(formattedCards);
            })
            .catch(error => console.error("⚠️ Error cargando la base de datos de cartas", error));
    }, [edition]);

    const importDeck = async () => {
        setIsImporting(true); // 🔹 Activa el spinner
        if (!deckCode) {
            alert("Por favor, ingresa un código de mazo.");
            logEvent({
                category: "ImportDeck",
                action: "Intento sin código",
                label: "Campo vacío"
            });
            return;
        }

        logEvent({
            category: "ImportDeck",
            action: "Intento de importación",
            label: `Código: ${deckCode}`
        });

        try {
            const response = await fetch(`${API_URL}/import`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ deck_code: deckCode })
            });

            if (!response.ok) {
                logEvent({
                    category: "ImportDeck",
                    action: "Fallo HTTP",
                    label: `Código: ${deckCode}`,
                    value: response.status
                });
                throw new Error(`Error HTTP: ${response.status}`);
            }

            const data = await response.json();

            if (!data?.deck?.cards) {
                alert("⚠️ No se encontró el mazo o está vacío.");
                logEvent({
                    category: "ImportDeck",
                    action: "Mazo vacío o no encontrado",
                    label: `Código: ${deckCode}`
                });
                return;
            }

            const enrichDeckData = (deck, database) => ({
                ...deck,
                cards: Object.entries(deck.cards).map(([id, quantity]) => {
                    const cardInfo = database.find(card => card.Id == id) || {};
                    return {
                        ...cardInfo,
                        quantity,
                        mini_img: cardInfo.mini_img || "URL_IMAGEN_DEFECTO"
                    };
                })
            });

            const enrichedPayload = enrichDeckData(data.deck, cardDatabase);
            const formattedDeck = Object.values(enrichedPayload.cards);

            dispatch({ type: "IMPORT_DECK", payload: formattedDeck });
            dispatch({ type: "UPDATE_DECK_GROUPS" });

            logEvent({
                category: "ImportDeck",
                action: "Importación exitosa",
                label: `Cartas: ${formattedDeck.length}`
            });

        } catch (error) {
            console.error("⚠️ Error al importar:", error);
            logEvent({
                category: "ImportDeck",
                action: "Error JS",
                label: error.message
            });
        } finally {
        setIsImporting(false); // 🔹 Desactiva el spinner al finalizar
    }
    };

    return (
        <div className="import">
            <h2>Importar Mazo</h2>
            <div className="import-container">
                <input
                    type="text"
                    value={deckCode}
                    onChange={(e) => setDeckCode(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") importDeck();
                    }}
                    placeholder="Introduce el código del mazo"
                    className="import-input"
                />
                <button onClick={importDeck} className="import-button" disabled={isImporting}>
                {isImporting ? (
                    <i className="fa-solid fa-spinner fa-spin"></i>
                ) : (
                    <i className="fa-solid fa-file-import"></i>
                )}
                </button>
            </div>
        </div>
    );
};

export default ImportDeck;
